import { skills } from "../lib/profile";

const skillColors = [
  "var(--c-industry)",
  "var(--c-leading)",
  "var(--c-university)",
  "var(--c-personal)",
];

export function About() {
  return (
    <section className="about" id="about">
      <div className="about__intro">
        <span className="eyebrow" data-reveal>
          About
        </span>
        <p className="about__lead" data-reveal>
          I&rsquo;m a full-stack developer and UI/UX designer who likes living
          in the space between <span className="hl hl--blue">engineering</span>{" "}
          and <span className="hl">design</span> — where a hard technical
          problem becomes a{" "}
          <span className="hl hl--green">simple, considered</span> experience.
        </p>
        <p className="about__detail" data-reveal>
          I&rsquo;ve shaped experimentation tooling at Atlassian, automated
          network workflows at Optus, and built independent products across
          education, film and social impact — including the meditation platforms
          I lead today.
        </p>
      </div>

      <div className="about__skills">
        {skills.map((group, i) => (
          <div
            className="about__skill"
            key={group.label}
            data-reveal
            style={
              {
                "--chip": skillColors[i % skillColors.length],
              } as React.CSSProperties
            }
          >
            <h4>{group.label}</h4>
            <ul>
              {group.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
